<script lang="ts">
  import RadioGroup from "../../../components/RadioGroup.svelte";
  import { type Component } from "svelte";
  import HowToIdentifyFinanceCompany from "../../HowToIdentifyFinanceCompany.svelte";

  let {
    answer,
    back,
    inactive,
    financeCompany,
    nextSteps,
  }: {
    answer: ({ nextStep, status }) => void;
    back: () => void;
    inactive: boolean;
    financeCompany: string;
    nextSteps: { [key: string]: Component };
  } = $props();

  let selectedOption = $state(null);
  let nextStep = $derived({
    unchanged: nextSteps.next,
    changed: nextSteps.change,
    not_financed: nextSteps.close
  }[selectedOption])

  function handleContinue() {
    if(!nextStep) return;
    answer({ nextStep, status: selectedOption });
  }
</script>

<div class="h-full">
  <fieldset class="ui-fieldset">
    <legend>
      <span>Did you finance this vehicle with <b>{financeCompany}</b>?</span>
    </legend>
    <RadioGroup
      name="finance_company[status]"
      options={[
        [`Yes, ${financeCompany}`, "unchanged"],
        ["No, a different finance company", "changed"],
        ["No financing: I purchased it outright", "not_financed"]
      ]}
      bind:group={selectedOption}
    />
  </fieldset>

  <div class="divider"></div>
  <HowToIdentifyFinanceCompany />
</div>

<div class="floating-footer">
  <button type="button" class="btn btn-ghost" onclick={back}>Back</button>
  <button
    type="submit"
    class="btn btn-primary"
    onclick={handleContinue}
    disabled={!selectedOption || inactive}>Continue</button
  >
</div>
